<template>
  <div class="content">
    <div class="container">
      <h1 class="mb-5">
        Campaigns
      </h1>

      <nav-campaign tab="campaign" />

      <card-box>
        <!--  <div class="row">
                <div class="col ">
                  &lt;!&ndash;  <div class="m-0 align-middle">
                        <toggle-button :width="80" :labels="{checked: 'Public', unchecked: 'Private'}" :height="31"
                                       :margin="1" @change="campaignType" :sync="true"></toggle-button>
                    </div>&ndash;&gt;
                </div>
                <div class="col text-right">

                </div>
            </div>-->


        <popover :width="500" :pointer="true" name="tag">
          <div class="d-flex">
            <div class="flex-grow-1 ">
              <vue-tags-input v-model="tag" :tags="tags" @tags-changed="newTags => tags = newTags" />
            </div>
            <div class="text-right">
              <div style="width: 135px">
                <button class="btn btn-success  mr-2" @click="setTag">
                  Tag
                </button>
                <button class="btn btn-success" @click="unTag">
                  Untag
                </button>
              </div>
            </div>
          </div>
        </popover>
        <div class="d-flex">
          <div class="flex-fill">
            <button class="btn btn-outline-secondary mr-2" @click="remove">
              Delete
            </button>
            <button v-popover:tag class="btn btn-outline-secondary mr-2">
              Tag
            </button>


            <button class="btn btn-outline-secondary mr-2" @click="fetch">
              <i class="fi fi-repeat" />
            </button>
          </div>
          <div class="flex-fill">
            <div class="d-flex">
              <div class="w-100 flex-fill">
                <div class="input-group mr-2 ">
                  <input v-model="keyword" type="text" class="form-control input-search" placeholder="Product Name, Tag or SKU"
                         @keyup.enter="fetch">
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button" @click="fetch">
                      <i class="fi-search" />
                    </button>
                  </div>
                </div>
              </div>
              <!--  <div class="flex-fill ml-2 text-right">


                    <div class="dropdown">
                        <button class="btn btn-outline-secondary dropdown-toggle" type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Feed
                        </button>
                        <div class="dropdown-menu" e-labelledby="dropdownMenuButton">
                            <router-link class="dropdown-item" :to="'/campaign/export/google'">Google Merchant

                            </router-link>
                            <router-link class="dropdown-item" :to="'/campaign/export/facebook'">Facebook
                                Catalog
                            </router-link>
                        </div>
                    </div>

                                                    <router-link class="btn btn-outline-secondary mr-2" to="/campaign/create"><i
                                                            class="fi-plus"></i> Create
                                                    </router-link>


                </div> -->
            </div>
          </div>
        </div>
        <div class="table-fluid mt-4">
          <table class="table table-hover w-100 d-block d-md-table table-responsive">
            <thead>
            <tr>
              <th width="30">
                <div class="custom-control custom-checkbox">
                  <input id="selectall" type="checkbox" class="custom-control-input" name="select">
                  <label class="custom-control-label" for="selectall" @click="selectAll" />
                </div>
              </th>
              <th width="100">
                THUMBNAIL
              </th>
              <th>NAME</th>
              <!--   <th>TAGS</th>-->
              <!--           <th>PROFIT</th>
                       <th>ORDERS</th>
                       <th>ITEMS</th>-->
              <th class="text-right">
                ACTION
              </th>
            </tr>
            </thead>
            <tbody>
            <campaign-row v-for="item in products" :key="item.id" :item="item" @update="item = $event;" />
            </tbody>
          </table>
          <result-not-found :result="products" />
        </div>
      </card-box>
      <div>
        <nav>
          <ul class="pagination justify-content-center ">
            <li class="page-item " :class="{disabled:page == 1}">
              <a class="page-link" href="#" tabindex="-1" @click="previous">Previous</a>
            </li>
            <li class="page-item ">
              <span class="page-link text-muted">{{ (page - 1) * limit }} - {{ page*limit }}</span>
            </li>
            <li class="page-item" :class="{disabled: products.length == 0}">
              <a class="page-link" href="#" @click="next">Next</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
    import CampaignRow from "@/components/CampaignRow";
    import ResultNotFound from "@/components/ResultNotFound"
    import CardBox from "@/components/CardBox"
    import VueTagsInput from '@johmun/vue-tags-input'
    import NavCampaign from "../components/NavCampaign";


    export default {
        name: "Campaign",
        components: {NavCampaign, CardBox, ResultNotFound, CampaignRow, VueTagsInput},
        data: function () {
            return {

                tag: '',
                tags: [],
                products: [],
                keyword: '',
                cursor: '',
                select: false,
                type: true,
                cardName: 'Public campaigns',
                limit: 15,
                page: 1,

            }
        },
        watch: {
            type: function () {
                this.page = 1
                this.fetch()
            }
        },
        mounted: function () {
            this.$store.commit('ACTIVE_SIDEBAR', 'campaign')
            this.keyword = this.$route.query.keyword || ''
            this.type = this.$route.query.public || true
            this.fetch()
            //  this.$bus.sidebar = 'setting'
        },
        methods: {
            previous: function () {
                if (this.page > 1) {
                    this.page = this.page - 1;
                }
                this.fetch()
            },
            next: function () {
                this.page = this.page + 1;
                this.fetch()
            },
            campaignType: function () {
                this.type = this.type ? false : true;
                this.cardName = this.type ? 'Public campaigns' : 'Private campaigns'
            },
            fetch: function () {
                let vm = this
                let query = '?public=' + this.type

                if (this.keyword != '') {
                    query += '&keyword=' + encodeURIComponent(this.keyword)
                }
                let offset = (this.page - 1) * this.limit
                query += '&limit=' + this.limit
                query += '&offset=' + offset

                this.$http.get(this.$config.api + 'campaigns' + query).then(function (res) {
                    vm.products = res.data.results
                })
            },
            selectAll: function () {
                this.select = (this.select == true) ? false : true

                for (let i = 0; i < this.products.length; i++) {
                    this.$set(this.products[i], 'select', this.select)
                }
            },

            setTag: async function () {
                let count = 0;
                for (let i = 0; i < this.products.length; i++) {
                    if (this.products[i].authorized == true) {
                        count++
                    }
                }

                if (count == 0) {
                    this.$swal('Please select your campaign !');
                    return false
                }


                let tags = []
                for (let i = 0; i < this.tags.length; i++) {
                    tags.push(this.tags[i].text)
                }


                if (tags.length == 0) {
                    this.$swal('Please enter Tag!');
                    return false
                }

                for (let i = 0; i < this.products.length; i++) {

                    if (this.products[i].select == true) {
                        await this.$http.post(this.$config.api + 'campaign/tag/' + this.products[i].id, {tags: tags})
                    }
                }
                await this.$helper.wait(5000)

                this.$swal('Update tag successfull')
                this.fetch()

            },
            unTag: async function () {
                let count = 0;
                for (let i = 0; i < this.products.length; i++) {
                    if (this.products[i].authorized == true) {
                        count++
                    }
                }

                if (count == 0) {
                    this.$swal('Please select your campaign !');
                    return false
                }

                let tags = []
                for (let i = 0; i < this.tags.length; i++) {
                    tags.push(this.tags[i].text)
                }


                if (tags.length == 0) {
                    this.$swal('Please enter Tag!');
                    return false
                }


                for (let i = 0; i < this.products.length; i++) {
                    if (this.products[i].select == true) {
                        await this.$http.post(this.$config.api + 'campaign/untag/' + this.products[i].id, {tags: tags})
                    }
                }

                await this.$helper.wait(5000)

                this.$swal('Untag successfully')
                this.fetch()

            },

            remove: function () {
                let vm = this
                let count = 0;
                for (let i = 0; i < this.products.length; i++) {
                    if (this.products[i].authorized == true) {
                        count++
                    }
                }

                if (count == 0) {
                    this.$swal('Please select your campaign !');
                    return false
                }

                this.$swal({
                    title: 'Are you sure?',
                    text: 'You cant revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then(async (result) => {
                    if (result.value) {
                      let count_deleted = 0;
                        for (let i = 0; i < vm.products.length; i++) {

                            if (vm.products[i].select == true) {
                                await vm.$http.delete(this.$config.api + 'campaign/' + vm.products[i].id)
                              count_deleted++;
                                vm.$set(vm.products[i], 'is_deleted', true)

                            }
                        }
                        await this.$helper.wait(3000)
                        vm.fetch()
                        vm.$swal('Deleted', 'You successfully deleted ' + count_deleted + ' campaigns', 'success')
                    } else {
                        vm.$swal('Cancelled', 'Your campaign is still intact', 'info')
                    }
                })
            }

        }

    }
</script>

<style lang="scss" scoped>

    .page-item {
        width: 100px;
        text-align: center;

        &:last-child {

        }
    }

    .input-search {
        border-color: #6c757d;
    }

    .table-fluid {
        margin: -1em;
    }

</style>